import { SearchModel } from "../../../core/core";

export class RentalItemStateSearchModel extends SearchModel {
  rentalRequestId: string;
  rentalRequestIds: string[];
  pendingRentalRequest: boolean;
  renterAccountId: string;
  ownerAccountId: string;
}
